
export interface GoogleAdsLocationGq {
  id: number;
  name: string;
  canonicalName: string;
  targetType?: string;
  countryCode?: string;
}

export const GoogleAdsLocationGqProps = `
  id  
  name
  canonicalName
  targetType
  countryCode
`;
